export const environment = {
  apiBaseUrl: 'https://api.vota.natrixsoftware.in/v1',
  stripeKey:
    'pk_test_51RWyAYCukciRA4x2KirgBBkZV0AMZ0gysqJCL0tGsfskoS6zu3Ls1IakihLpoKAafQML1rdtJO9lq64EaO1Bfqdj00CYi8IWrY',
};
